import { render, staticRenderFns } from "./LISSpecimenType.vue?vue&type=template&id=56faa98a&scoped=true"
import script from "./LISSpecimenType.vue?vue&type=script&lang=js"
export * from "./LISSpecimenType.vue?vue&type=script&lang=js"
import style0 from "./LISSpecimenType.vue?vue&type=style&index=0&id=56faa98a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56faa98a",
  null
  
)

export default component.exports